// 默认请求路径
const baseURL = {
	// http:'http://slapi.zjc158.com/searched-api/',//正式
	// http:'http://appapi.sootoken.com.cn/searched-api',//正式
	
	// http:'http://wzh.imwap.cn/showcsm/',
	// http:'http://xiaomi.sootoken.com.cn/',
	// http:'http://192.168.1.69:6080/showcsm/',
	// http:'https://zb.sootoken.com.cn/showcsm/',
	// http:'http://192.168.1.3:8093/searched-api/',//陈绍波
	// http:'http://192.168.1.29:8093/searched-api/api/',//王中华
	// http:'http://plate.imwap.cn/searched-api/api/',//王中华
	// http:'http://192.168.1.24:8094/searched-api/api/',//苏苏
	
	// http:'https://appapi.sootoken.com.cn/searched-api/api/',//搜了宝积分系统 正式
	http:'http://appapi.sootoken.com.cn/searched-api/',//年会 中奖查询正式
	
	
}
export default baseURL;


// WEBPACK FOOTER //
// ./src/common/api_url/baseURL.js